import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Successes } from 'src/infrastructure/labels/successes';
import { Favourite } from 'src/models/DTO/favourite/favourite';
import { FavouriteItem } from 'src/models/DTO/favourite/favouriteItem';
import { UserDTO } from 'src/models/DTO/user/user';
import { createFavouriteRequestModel } from 'src/models/requestModels/favourites/createFavouriteRequestModel';
import { ToastService } from 'src/services/core/toast/toast.service';
import { FavouritesService } from 'src/services/request/favourites/favourites.service';
import { ImagesService } from 'src/services/request/images/images.service';
import { RatingsService } from 'src/services/request/ratings/ratings.service';
import { HistoryService } from 'src/services/state/history/history.service';
import { LoggedUserService } from 'src/services/state/loggeduser/loggeduser.service';

@Component({
  selector: 'app-whishlist',
  templateUrl: './whishlist.component.html',
  styleUrls: ['./whishlist.component.css']
})
export class WhishlistComponent extends HistoryBaseComponent implements OnInit {
  private _loggedUser?: UserDTO;
  private _favourites: Favourite = { data: [] };
  private _loading = true;

  constructor(
    private favouriteService: FavouritesService,
    private loggedUserService: LoggedUserService,
    private imagesService: ImagesService,
    private toast: ToastService,
    private router: Router,
    private ratingsService: RatingsService,
    protected location: Location,
    protected historyService: HistoryService
  ) {
    super(location, historyService);

    this.loggedUserService.userInfo$.subscribe((user) => {
      if (!Object.keys(user).length) {
        return;
      }

      this._loggedUser = user;
      this.loadFavourites();
    });
  }

  ngOnInit(): void {}

  get favourites(): FavouriteItem[] {
    return this._favourites.data;
  }

  get loading(): boolean {
    return this._loading;
  }

  goToCategories(): void {
    this.router.navigate(['categories']);
  }

  private loadFavourites(): void {
    this.favouriteService.getAllFavouritesForUser(this._loggedUser!.data.uuid).subscribe((products) => {
      if (!products) {
        this._favourites.data = [];
        this._loading = false;
        return;
      }

      this._favourites = products;

      this._favourites.data.forEach((favourite) => {
        this.imagesService.getImagesForProduct('PRODUCT', favourite.uuid).subscribe((images) => {
          favourite.imageSrc = images.data[0]?.original?.url || '/assets/images/shared/logo.png';
        });

        this.getRatingsForProduct(favourite);
      });

      this._loading = false;
    });
  }

  private getRatingsForProduct(product: FavouriteItem): void {
    this.ratingsService.getRatingsPerProduct(product.uuid).subscribe((ratings) => {
      product.ratings = ratings;
      this.getRatingsAvg(product);
    });
  }

  private getRatingsAvg(product: FavouriteItem): void {
    let ratingsScore = 0;
    const ratingsCount = product.ratings?.data.length || 0;

    product.ratings?.data.forEach((rating) => {
      ratingsScore += rating.rating;
    });

    product.ratingAvgValue = ratingsCount ? ratingsScore / ratingsCount : 0;
  }

  openItem(productUUID: string, categoryUUID: string): void {
    this.router.navigate(['product/' + productUUID.toString() + '/' + categoryUUID]);
  }

  getProductCardBasePrice(product: FavouriteItem): number {
    const pricing = product?.pricing || [];
    if (!pricing.length) {
      return 0;
    }

    const singleQtyPricing =
      pricing.find((price) => Number(price.quantity_from) === 1) || pricing[0];

    return Number(singleQtyPricing?.price_per_piece) || 0;
  }

  hasProductPrice(product: FavouriteItem): boolean {
    return this.getProductCardBasePrice(product) > 0;
  }

  // public getPriceRange(product: FavouriteItem): string[] {
  //   const price = this.getProductCardBasePrice(product);
  //   if (!price) {
  //     return [];
  //   }
  //
  //   const fixedPrice = price.toFixed(2);
  //   const priceArray = fixedPrice.split('.');
  //   priceArray[0] = priceArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  //
  //   return priceArray;
  // }

  removeFromFavourites(productUuidToRemove: string, event: any): void {
    const createFavouriteModel: createFavouriteRequestModel = {
      product_uuid: productUuidToRemove
    };

    this.favouriteService.removeFavourite(createFavouriteModel).subscribe(() => {
      this.loadFavourites();
      this.toast.success(Successes.bg.unfavourite);
    });

    event.stopPropagation();
  }
}
